import { ADD_COMMON_LOADER, REMOVE_COMMON_LOADER } from './types';

export const addCommonLoader = () => ({ type: ADD_COMMON_LOADER });

export const removeCommonLoader = () => ({ type: REMOVE_COMMON_LOADER });
